module.exports = __webpack_public_path__ + "media/images/wishlistOn-f43f5ee921a3f4b63b500b298044c996.svg";